module.exports = __webpack_public_path__ + "static/media/Arial_Rounded_MT.2060901a.svg";